import styled, { css } from 'styled-components/macro';
import Select from 'react-select';
import { IWorkerSelectProps } from './workers-select.types';

export const Wrapper = styled.div<{
  direction: IWorkerSelectProps['direction'];
  $contained?: boolean;
}>`
  display: flex;
  flex-direction: ${(props) => props.direction};
  gap: 12px;
  overflow: hidden;

  ${({ $contained }) =>
    $contained
      ? css`
          flex: none;
          align-items: stretch;
          margin: 0;
          padding: 0;
          min-width: 0;
          width: 100%;

          & > * {
            min-width: 0;
            width: 100%;
          }
        `
      : css`
          flex: 1;
          padding: 10px;
          margin: -10px;
        `}
`;

export const StyledSelect = styled(Select)`
  line-height: 18px;
  font-size: 14px;
  font-weight: 400;
  z-index: 100;
  width: 100%;
`;
